import { Link, useLocation } from "@tanstack/react-router";
import { useT } from "../i18n";

/* ══════════════════════════════════════════════════════════════════
   Eine Adresse, die es nicht gibt (A-30/A-34, 03.10.2026).

   Bis hierhin stand dort der Standardsatz des Routers: „Not Found" — auf
   Englisch, ohne Weg zurück, neben der Seitenleiste. Kalle landete darauf mit
   einer abgetippten Adresse, Wilma mit `/gibtsnicht`. Jetzt steht ein
   deutscher Satz da, die Adresse zum Abgleichen, und der Weg zur Startseite.

   Dieselbe Form wie die Seite für eine Maske, die nicht zeichnen kann
   (`schale/Ladefehler.tsx`), damit beides gleich aussieht.
   ══════════════════════════════════════════════════════════════════ */
export function Unbekannt() {
  const t = useT();
  const { pathname } = useLocation();
  return (
    <main className="ladefehler" role="alert">
      <h1>{t("unbekannt.titel")}</h1>
      <p>{t("unbekannt.satz")}</p>
      <Link to="/heute" className="knopf haupt">{t("unbekannt.zurStart")}</Link>
      <p className="ladefehler-wortlaut">{pathname}</p>
    </main>
  );
}
